export default [{
	header: 'Licitaciones',
	icon: 'BookmarkIcon',
	children: [		
		{
			title: 'Lista',
			route: 'competitions-list',
			icon: 'ListIcon',
			action: 'read',
			resource: 'tenders'
		},
	]
}];